/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createFileRoute,
  useNavigate,
  useSearch,
} from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { AdminNav } from '../components/AdminNav';

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: (search.redirect as string | undefined),
  }),
  component: LoginPage,
});

function LoginPage() {
  usePageMeta('Login | Boyden Renovations', undefined, true);

  const navigate = useNavigate();
  const search = useSearch({ from: '/login' });
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const attach = (identity: any) => {
      // Widget already initialized — check immediately
      // Also verify the sessionStorage flag so a freshly-opened tab doesn't
      // show as logged in before requireAuth clears the stale localStorage token.
      if (identity.currentUser() && sessionStorage.getItem('admin_session')) {
        setLoggedIn(true);
        return () => {};
      }

      const handleInit = (user: any) => setLoggedIn(!!user);
      const handleLogin = () => {
        sessionStorage.setItem('admin_session', '1');
        identity.close();
        navigate({ to: search.redirect ?? '/projects' });
      };
      const handleLogout = () => {
        sessionStorage.removeItem('admin_session');
        setLoggedIn(false);
      };

      identity.on('init', handleInit);
      identity.on('login', handleLogin);
      identity.on('logout', handleLogout);

      return () => {
        identity.off('init', handleInit);
        identity.off('login', handleLogin);
        identity.off('logout', handleLogout);
      };
    };

    if ((window as any).netlifyIdentity) {
      return attach((window as any).netlifyIdentity);
    }

    let cleanup = () => {};
    const script = document.createElement('script');
    script.src = 'https://identity.netlify.com/v1/netlify-identity-widget.js';
    script.async = true;
    script.onload = () => {
      cleanup = attach((window as any).netlifyIdentity) ?? (() => {});
    };
    document.head.appendChild(script);
    return () => cleanup();
  }, [navigate, search]);

  const openLogin = () => {
    (window as any).netlifyIdentity?.open('login');
  };

  return (
    <div className="min-h-screen font-sans text-neutral-dark flex flex-col">
      {loggedIn && <AdminNav />}
      <div className="flex-1 flex flex-col items-center justify-center gap-6">
        <h1 className="text-3xl font-serif tracking-widest uppercase">Boyden Renovations</h1>
        <p className="text-xs tracking-[3px] uppercase text-neutral-dark/40">Admin</p>
        {!loggedIn && (
          <button
            onClick={openLogin}
            className="text-xs tracking-[4px] font-sans font-light uppercase border border-neutral-dark px-8 py-3 hover:opacity-70 transition-opacity duration-300 mt-2"
          >
            Login
          </button>
        )}
      </div>
    </div>
  );
}
